import { ReactElement, useEffect } from 'react'
import SelectEntity from 'src/v3/components/select-entity'
import LinkedServiceSelector from 'src/v3/components/linked-service'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import useSession from 'src/authentication/hooks/use-session'
import {
  fetchLinkedServices,
  selectLinkedServicesByIds,
  selectLinkedServicesStatus,
  selectActiveLinkedService,
  activeLinkedServiceChanged,
  selectActiveSection,
  selectSectionsByLinkedService,
  selectSectionsStatus,
  activeSectionChanged,
  fetchSections,
  selectActiveCourse,
  selectCoursesBySectionID,
  selectCoursesStatus,
  activeCourseChanged,
  fetchCourses,
  selectActiveClass,
  selectClassesByCourseID,
  selectClassesStatus,
  activeClassChanged,
  fetchClasses,
} from '../create.slice'

export let SelectLinkedService = (): ReactElement => {
  let dispatch = useAppDispatch()
  let session = useSession()

  let linkedServiceID = useAppSelector(selectActiveLinkedService)
  let linkedServicesStatus = useAppSelector(selectLinkedServicesStatus)
  let linkedServices = useAppSelector(
    selectLinkedServicesByIds(session?.linkedServices ?? []),
  )

  useEffect(() => {
    if (linkedServicesStatus === 'uninitialized') {
      dispatch(fetchLinkedServices())
    } else if (linkedServicesStatus === 'fulfilled') {
      if (
        !session?.roles.includes('admin') &&
        linkedServices.length === 1 &&
        linkedServices[0].id
      ) {
        dispatch(activeLinkedServiceChanged(linkedServices[0].id))
      }
    }
  }, [linkedServicesStatus])

  return (
    <LinkedServiceSelector
      linkedServiceID={linkedServiceID}
      linkedServices={linkedServices}
      activeLinkedServiceChanged={activeLinkedServiceChanged}
    />
  )
}

export let SelectSection = (): ReactElement => {
  let dispatch = useAppDispatch()

  let activeLinkedService = useAppSelector(selectActiveLinkedService)
  let sectionsStatus = useAppSelector(selectSectionsStatus)
  let sections = useAppSelector(
    selectSectionsByLinkedService(activeLinkedService),
  )
  let section = useAppSelector(selectActiveSection)

  useEffect(() => {
    if (sectionsStatus === 'uninitialized') {
      dispatch(fetchSections())
    } else if (sectionsStatus === 'fulfilled') {
      if (
        sections.length === 1 &&
        sections[0].id &&
        sections[0].id !== section
      ) {
        dispatch(activeSectionChanged(sections[0].id))
      }
    }
  }, [sectionsStatus])

  return (
    <SelectEntity
      name="Section"
      entityID={section}
      entities={sections}
      activeEntityChanged={activeSectionChanged}
    />
  )
}

export let SelectCourse = (): ReactElement => {
  let dispatch = useAppDispatch()

  let section = useAppSelector(selectActiveSection)
  let coursesStatus = useAppSelector(selectCoursesStatus)
  let courses = useAppSelector(selectCoursesBySectionID(section))
  let course = useAppSelector(selectActiveCourse)

  useEffect(() => {
    if (coursesStatus === 'uninitialized') {
      dispatch(fetchCourses())
    } else if (coursesStatus === 'fulfilled') {
      if (courses.length === 1 && courses[0].id && courses[0].id !== course) {
        dispatch(activeCourseChanged(courses[0].id))
      }
    }
  }, [coursesStatus])

  return (
    <SelectEntity
      name="Course"
      entityID={course}
      entities={courses}
      activeEntityChanged={activeCourseChanged}
    />
  )
}
export let SelectClass = (): ReactElement => {
  let dispatch = useAppDispatch()

  let course = useAppSelector(selectActiveCourse)
  let classesStatus = useAppSelector(selectClassesStatus)
  let classes = useAppSelector(selectClassesByCourseID(course))
  let classData = useAppSelector(selectActiveClass)

  useEffect(() => {
    if (classesStatus === 'uninitialized') {
      dispatch(fetchClasses())
    } else if (classesStatus === 'fulfilled') {
      if (
        classes.length === 1 &&
        classes[0].id &&
        classes[0].id !== classData
      ) {
        dispatch(activeClassChanged(classes[0].id))
      }
    }
  }, [classesStatus])

  return (
    <SelectEntity
      name="Class"
      entityID={classData}
      entities={classes}
      activeEntityChanged={activeClassChanged}
    />
  )
}
